import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/services', label: 'Services' },
    { path: '/roster', label: 'Roster' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <header className="header" data-testid="main-header">
      <div className="header-container">
        <Link to="/" className="logo" data-testid="logo-link">
          Woodhouse & Archer
        </Link>

        <button 
          className="mobile-nav-toggle" 
          onClick={() => setIsOpen(!isOpen)}
          data-testid="mobile-nav-toggle"
          aria-label="Toggle navigation"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        <nav className={`nav-links ${isOpen ? 'open' : ''}`} data-testid="nav-links">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => setIsOpen(false)}
              data-testid={`nav-${link.label.toLowerCase()}`}
            >
              {link.label}
            </Link>
          ))}
          <Link 
            to="/register" 
            className="btn btn-primary"
            onClick={() => setIsOpen(false)}
            data-testid="nav-join-btn"
          >
            Join Us
          </Link>
        </nav>
      </div>
    </header>
  );
}
